// Code generated by @hex-insights/frontend-generator; DO NOT EDIT.

export type GraphTypeNames = {
	AcademicSubject: "AcademicSubject";
	AcademicSubjectConnection: "AcademicSubjectConnection";
	AcademicSubjectEdge: "AcademicSubjectEdge";
	AcademicTerm: "AcademicTerm";
	AcademicTermConnection: "AcademicTermConnection";
	AcademicTermEdge: "AcademicTermEdge";
	AcademicYear: "AcademicYear";
	AcademicYearConnection: "AcademicYearConnection";
	AcademicYearEdge: "AcademicYearEdge";
	Address: "Address";
	AddressConnection: "AddressConnection";
	AddressEdge: "AddressEdge";
	Announcement: "Announcement";
	AnnouncementConnection: "AnnouncementConnection";
	AnnouncementEdge: "AnnouncementEdge";
	AttendanceStatus: "AttendanceStatus";
	AttendanceStatusConnection: "AttendanceStatusConnection";
	AttendanceStatusEdge: "AttendanceStatusEdge";
	BillingAdjustment: "BillingAdjustment";
	BillingAdjustmentConnection: "BillingAdjustmentConnection";
	BillingAdjustmentEdge: "BillingAdjustmentEdge";
	Building: "Building";
	BuildingConnection: "BuildingConnection";
	BuildingEdge: "BuildingEdge";
	BuildingFloor: "BuildingFloor";
	BuildingFloorConnection: "BuildingFloorConnection";
	BuildingFloorEdge: "BuildingFloorEdge";
	CalendarEvent: "CalendarEvent";
	CalendarEventConnection: "CalendarEventConnection";
	CalendarEventEdge: "CalendarEventEdge";
	CalendarEventResponse: "CalendarEventResponse";
	CalendarEventResponseConnection: "CalendarEventResponseConnection";
	CalendarEventResponseEdge: "CalendarEventResponseEdge";
	Campus: "Campus";
	CampusConnection: "CampusConnection";
	CampusEdge: "CampusEdge";
	ClassYear: "ClassYear";
	ClassYearConnection: "ClassYearConnection";
	ClassYearEdge: "ClassYearEdge";
	ClassYearCategory: "ClassYearCategory";
	ClassYearCategoryConnection: "ClassYearCategoryConnection";
	ClassYearCategoryEdge: "ClassYearCategoryEdge";
	Contract: "Contract";
	ContractConnection: "ContractConnection";
	ContractEdge: "ContractEdge";
	ContractInstallment: "ContractInstallment";
	ContractInstallmentConnection: "ContractInstallmentConnection";
	ContractInstallmentEdge: "ContractInstallmentEdge";
	ContractLineItem: "ContractLineItem";
	ContractLineItemConnection: "ContractLineItemConnection";
	ContractLineItemEdge: "ContractLineItemEdge";
	Country: "Country";
	CountryConnection: "CountryConnection";
	CountryEdge: "CountryEdge";
	Course: "Course";
	CourseConnection: "CourseConnection";
	CourseEdge: "CourseEdge";
	CourseAssessment: "CourseAssessment";
	CourseAssessmentConnection: "CourseAssessmentConnection";
	CourseAssessmentEdge: "CourseAssessmentEdge";
	CourseAssessmentCategory: "CourseAssessmentCategory";
	CourseAssessmentCategoryConnection: "CourseAssessmentCategoryConnection";
	CourseAssessmentCategoryEdge: "CourseAssessmentCategoryEdge";
	CourseAssessmentCategoryMarkPortion: "CourseAssessmentCategoryMarkPortion";
	CourseAssessmentCategoryMarkPortionConnection: "CourseAssessmentCategoryMarkPortionConnection";
	CourseAssessmentCategoryMarkPortionEdge: "CourseAssessmentCategoryMarkPortionEdge";
	CourseAssessmentMark: "CourseAssessmentMark";
	CourseAssessmentMarkConnection: "CourseAssessmentMarkConnection";
	CourseAssessmentMarkEdge: "CourseAssessmentMarkEdge";
	CourseAssessmentSubmission: "CourseAssessmentSubmission";
	CourseAssessmentSubmissionConnection: "CourseAssessmentSubmissionConnection";
	CourseAssessmentSubmissionEdge: "CourseAssessmentSubmissionEdge";
	CourseAssessmentTiming: "CourseAssessmentTiming";
	CourseAssessmentTimingConnection: "CourseAssessmentTimingConnection";
	CourseAssessmentTimingEdge: "CourseAssessmentTimingEdge";
	CourseAttendanceRecord: "CourseAttendanceRecord";
	CourseAttendanceRecordConnection: "CourseAttendanceRecordConnection";
	CourseAttendanceRecordEdge: "CourseAttendanceRecordEdge";
	CourseSection: "CourseSection";
	CourseSectionConnection: "CourseSectionConnection";
	CourseSectionEdge: "CourseSectionEdge";
	CourseSectionPeriod: "CourseSectionPeriod";
	CourseSectionPeriodConnection: "CourseSectionPeriodConnection";
	CourseSectionPeriodEdge: "CourseSectionPeriodEdge";
	Discount: "Discount";
	DiscountConnection: "DiscountConnection";
	DiscountEdge: "DiscountEdge";
	EmailAddress: "EmailAddress";
	EmailAddressConnection: "EmailAddressConnection";
	EmailAddressEdge: "EmailAddressEdge";
	Employee: "Employee";
	EmployeeConnection: "EmployeeConnection";
	EmployeeEdge: "EmployeeEdge";
	EnrollmentApplication: "EnrollmentApplication";
	EnrollmentApplicationConnection: "EnrollmentApplicationConnection";
	EnrollmentApplicationEdge: "EnrollmentApplicationEdge";
	EnrollmentApplicationGuardian: "EnrollmentApplicationGuardian";
	EnrollmentApplicationGuardianConnection: "EnrollmentApplicationGuardianConnection";
	EnrollmentApplicationGuardianEdge: "EnrollmentApplicationGuardianEdge";
	EnrollmentApplicationStudent: "EnrollmentApplicationStudent";
	EnrollmentApplicationStudentConnection: "EnrollmentApplicationStudentConnection";
	EnrollmentApplicationStudentEdge: "EnrollmentApplicationStudentEdge";
	EnrollmentApplicationStudentSchool: "EnrollmentApplicationStudentSchool";
	EnrollmentApplicationStudentSchoolConnection: "EnrollmentApplicationStudentSchoolConnection";
	EnrollmentApplicationStudentSchoolEdge: "EnrollmentApplicationStudentSchoolEdge";
	Guardian: "Guardian";
	GuardianConnection: "GuardianConnection";
	GuardianEdge: "GuardianEdge";
	HomeRoom: "HomeRoom";
	HomeRoomConnection: "HomeRoomConnection";
	HomeRoomEdge: "HomeRoomEdge";
	HomeRoomSection: "HomeRoomSection";
	HomeRoomSectionConnection: "HomeRoomSectionConnection";
	HomeRoomSectionEdge: "HomeRoomSectionEdge";
	Invoice: "Invoice";
	InvoiceConnection: "InvoiceConnection";
	InvoiceEdge: "InvoiceEdge";
	InvoiceLineItem: "InvoiceLineItem";
	InvoiceLineItemConnection: "InvoiceLineItemConnection";
	InvoiceLineItemEdge: "InvoiceLineItemEdge";
	Language: "Language";
	LanguageConnection: "LanguageConnection";
	LanguageEdge: "LanguageEdge";
	LearningObjective: "LearningObjective";
	LearningObjectiveConnection: "LearningObjectiveConnection";
	LearningObjectiveEdge: "LearningObjectiveEdge";
	LearningObjectiveCategory: "LearningObjectiveCategory";
	LearningObjectiveCategoryConnection: "LearningObjectiveCategoryConnection";
	LearningObjectiveCategoryEdge: "LearningObjectiveCategoryEdge";
	LoginRecord: "LoginRecord";
	LoginRecordConnection: "LoginRecordConnection";
	LoginRecordEdge: "LoginRecordEdge";
	MFAFactor: "MFAFactor";
	MFAFactorConnection: "MFAFactorConnection";
	MFAFactorEdge: "MFAFactorEdge";
	MFAInvalidOTPAttempt: "MFAInvalidOTPAttempt";
	MFAInvalidOTPAttemptConnection: "MFAInvalidOTPAttemptConnection";
	MFAInvalidOTPAttemptEdge: "MFAInvalidOTPAttemptEdge";
	MarkValue: "MarkValue";
	MarkValueConnection: "MarkValueConnection";
	MarkValueEdge: "MarkValueEdge";
	MarkingSystem: "MarkingSystem";
	MarkingSystemConnection: "MarkingSystemConnection";
	MarkingSystemEdge: "MarkingSystemEdge";
	MediaAttachment: "MediaAttachment";
	MediaAttachmentConnection: "MediaAttachmentConnection";
	MediaAttachmentEdge: "MediaAttachmentEdge";
	MedicalCondition: "MedicalCondition";
	MedicalConditionConnection: "MedicalConditionConnection";
	MedicalConditionEdge: "MedicalConditionEdge";
	Medication: "Medication";
	MedicationConnection: "MedicationConnection";
	MedicationEdge: "MedicationEdge";
	Message: "Message";
	MessageConnection: "MessageConnection";
	MessageEdge: "MessageEdge";
	MessageAvailabilityPeriod: "MessageAvailabilityPeriod";
	MessageAvailabilityPeriodConnection: "MessageAvailabilityPeriodConnection";
	MessageAvailabilityPeriodEdge: "MessageAvailabilityPeriodEdge";
	MessageGroup: "MessageGroup";
	MessageGroupConnection: "MessageGroupConnection";
	MessageGroupEdge: "MessageGroupEdge";
	MessageGroupArchivePoint: "MessageGroupArchivePoint";
	MessageGroupArchivePointConnection: "MessageGroupArchivePointConnection";
	MessageGroupArchivePointEdge: "MessageGroupArchivePointEdge";
	MessageTopic: "MessageTopic";
	MessageTopicConnection: "MessageTopicConnection";
	MessageTopicEdge: "MessageTopicEdge";
	Newsletter: "Newsletter";
	NewsletterConnection: "NewsletterConnection";
	NewsletterEdge: "NewsletterEdge";
	Payment: "Payment";
	PaymentConnection: "PaymentConnection";
	PaymentEdge: "PaymentEdge";
	PaymentLineItem: "PaymentLineItem";
	PaymentLineItemConnection: "PaymentLineItemConnection";
	PaymentLineItemEdge: "PaymentLineItemEdge";
	Permission: "Permission";
	PermissionConnection: "PermissionConnection";
	PermissionEdge: "PermissionEdge";
	PermissionGroup: "PermissionGroup";
	PermissionGroupConnection: "PermissionGroupConnection";
	PermissionGroupEdge: "PermissionGroupEdge";
	Person: "Person";
	PersonConnection: "PersonConnection";
	PersonEdge: "PersonEdge";
	PhoneNumber: "PhoneNumber";
	PhoneNumberConnection: "PhoneNumberConnection";
	PhoneNumberEdge: "PhoneNumberEdge";
	Post: "Post";
	PostConnection: "PostConnection";
	PostEdge: "PostEdge";
	Quotation: "Quotation";
	QuotationConnection: "QuotationConnection";
	QuotationEdge: "QuotationEdge";
	Refund: "Refund";
	RefundConnection: "RefundConnection";
	RefundEdge: "RefundEdge";
	Relationship: "Relationship";
	RelationshipConnection: "RelationshipConnection";
	RelationshipEdge: "RelationshipEdge";
	ReportCard: "ReportCard";
	ReportCardConnection: "ReportCardConnection";
	ReportCardEdge: "ReportCardEdge";
	ReportCardSection: "ReportCardSection";
	ReportCardSectionConnection: "ReportCardSectionConnection";
	ReportCardSectionEdge: "ReportCardSectionEdge";
	ReportCardSectionLearningObjective: "ReportCardSectionLearningObjective";
	ReportCardSectionLearningObjectiveConnection: "ReportCardSectionLearningObjectiveConnection";
	ReportCardSectionLearningObjectiveEdge: "ReportCardSectionLearningObjectiveEdge";
	ReportCardSectionPolicy: "ReportCardSectionPolicy";
	ReportCardSectionPolicyConnection: "ReportCardSectionPolicyConnection";
	ReportCardSectionPolicyEdge: "ReportCardSectionPolicyEdge";
	Room: "Room";
	RoomConnection: "RoomConnection";
	RoomEdge: "RoomEdge";
	SchoolAttendanceRecord: "SchoolAttendanceRecord";
	SchoolAttendanceRecordConnection: "SchoolAttendanceRecordConnection";
	SchoolAttendanceRecordEdge: "SchoolAttendanceRecordEdge";
	Service: "Service";
	ServiceConnection: "ServiceConnection";
	ServiceEdge: "ServiceEdge";
	Session: "Session";
	SessionConnection: "SessionConnection";
	SessionEdge: "SessionEdge";
	SharingRecord: "SharingRecord";
	SharingRecordConnection: "SharingRecordConnection";
	SharingRecordEdge: "SharingRecordEdge";
	SocialComment: "SocialComment";
	SocialCommentConnection: "SocialCommentConnection";
	SocialCommentEdge: "SocialCommentEdge";
	SocialReaction: "SocialReaction";
	SocialReactionConnection: "SocialReactionConnection";
	SocialReactionEdge: "SocialReactionEdge";
	Student: "Student";
	StudentConnection: "StudentConnection";
	StudentEdge: "StudentEdge";
	StudentAcademicNote: "StudentAcademicNote";
	StudentAcademicNoteConnection: "StudentAcademicNoteConnection";
	StudentAcademicNoteEdge: "StudentAcademicNoteEdge";
	StudentAcademicTermEnrollment: "StudentAcademicTermEnrollment";
	StudentAcademicTermEnrollmentConnection: "StudentAcademicTermEnrollmentConnection";
	StudentAcademicTermEnrollmentEdge: "StudentAcademicTermEnrollmentEdge";
	StudentAttendanceNote: "StudentAttendanceNote";
	StudentAttendanceNoteConnection: "StudentAttendanceNoteConnection";
	StudentAttendanceNoteEdge: "StudentAttendanceNoteEdge";
	StudentBehaviorNote: "StudentBehaviorNote";
	StudentBehaviorNoteConnection: "StudentBehaviorNoteConnection";
	StudentBehaviorNoteEdge: "StudentBehaviorNoteEdge";
	StudentCourseSectionEnrollment: "StudentCourseSectionEnrollment";
	StudentCourseSectionEnrollmentConnection: "StudentCourseSectionEnrollmentConnection";
	StudentCourseSectionEnrollmentEdge: "StudentCourseSectionEnrollmentEdge";
	StudentDataConsent: "StudentDataConsent";
	StudentDataConsentConnection: "StudentDataConsentConnection";
	StudentDataConsentEdge: "StudentDataConsentEdge";
	StudentEnrollmentApplication: "StudentEnrollmentApplication";
	StudentEnrollmentApplicationConnection: "StudentEnrollmentApplicationConnection";
	StudentEnrollmentApplicationEdge: "StudentEnrollmentApplicationEdge";
	StudentEnrollmentIntent: "StudentEnrollmentIntent";
	StudentEnrollmentIntentConnection: "StudentEnrollmentIntentConnection";
	StudentEnrollmentIntentEdge: "StudentEnrollmentIntentEdge";
	StudentHealthNote: "StudentHealthNote";
	StudentHealthNoteConnection: "StudentHealthNoteConnection";
	StudentHealthNoteEdge: "StudentHealthNoteEdge";
	StudentHomeRoomSectionEnrollment: "StudentHomeRoomSectionEnrollment";
	StudentHomeRoomSectionEnrollmentConnection: "StudentHomeRoomSectionEnrollmentConnection";
	StudentHomeRoomSectionEnrollmentEdge: "StudentHomeRoomSectionEnrollmentEdge";
	StudentIncidentNote: "StudentIncidentNote";
	StudentIncidentNoteConnection: "StudentIncidentNoteConnection";
	StudentIncidentNoteEdge: "StudentIncidentNoteEdge";
	StudentInformationVerification: "StudentInformationVerification";
	StudentInformationVerificationConnection: "StudentInformationVerificationConnection";
	StudentInformationVerificationEdge: "StudentInformationVerificationEdge";
	StudentInjuryNote: "StudentInjuryNote";
	StudentInjuryNoteConnection: "StudentInjuryNoteConnection";
	StudentInjuryNoteEdge: "StudentInjuryNoteEdge";
	StudentMedicalCondition: "StudentMedicalCondition";
	StudentMedicalConditionConnection: "StudentMedicalConditionConnection";
	StudentMedicalConditionEdge: "StudentMedicalConditionEdge";
	StudentMedicalContact: "StudentMedicalContact";
	StudentMedicalContactConnection: "StudentMedicalContactConnection";
	StudentMedicalContactEdge: "StudentMedicalContactEdge";
	StudentMedicalEvent: "StudentMedicalEvent";
	StudentMedicalEventConnection: "StudentMedicalEventConnection";
	StudentMedicalEventEdge: "StudentMedicalEventEdge";
	StudentMedicalProfile: "StudentMedicalProfile";
	StudentMedicalProfileConnection: "StudentMedicalProfileConnection";
	StudentMedicalProfileEdge: "StudentMedicalProfileEdge";
	StudentMedicationNote: "StudentMedicationNote";
	StudentMedicationNoteConnection: "StudentMedicationNoteConnection";
	StudentMedicationNoteEdge: "StudentMedicationNoteEdge";
	StudentNote: "StudentNote";
	StudentNoteConnection: "StudentNoteConnection";
	StudentNoteEdge: "StudentNoteEdge";
	StudentOTCMedication: "StudentOTCMedication";
	StudentOTCMedicationConnection: "StudentOTCMedicationConnection";
	StudentOTCMedicationEdge: "StudentOTCMedicationEdge";
	StudentPrescriptionMedication: "StudentPrescriptionMedication";
	StudentPrescriptionMedicationConnection: "StudentPrescriptionMedicationConnection";
	StudentPrescriptionMedicationEdge: "StudentPrescriptionMedicationEdge";
	StudentSocialEmotionalNote: "StudentSocialEmotionalNote";
	StudentSocialEmotionalNoteConnection: "StudentSocialEmotionalNoteConnection";
	StudentSocialEmotionalNoteEdge: "StudentSocialEmotionalNoteEdge";
	StudentVaccinationRecord: "StudentVaccinationRecord";
	StudentVaccinationRecordConnection: "StudentVaccinationRecordConnection";
	StudentVaccinationRecordEdge: "StudentVaccinationRecordEdge";
	TeacherCourseSectionEnrollment: "TeacherCourseSectionEnrollment";
	TeacherCourseSectionEnrollmentConnection: "TeacherCourseSectionEnrollmentConnection";
	TeacherCourseSectionEnrollmentEdge: "TeacherCourseSectionEnrollmentEdge";
	TeacherHomeRoomSectionEnrollment: "TeacherHomeRoomSectionEnrollment";
	TeacherHomeRoomSectionEnrollmentConnection: "TeacherHomeRoomSectionEnrollmentConnection";
	TeacherHomeRoomSectionEnrollmentEdge: "TeacherHomeRoomSectionEnrollmentEdge";
	TrustedDevice: "TrustedDevice";
	TrustedDeviceConnection: "TrustedDeviceConnection";
	TrustedDeviceEdge: "TrustedDeviceEdge";
	User: "User";
	UserConnection: "UserConnection";
	UserEdge: "UserEdge";
	UserGroup: "UserGroup";
	UserGroupConnection: "UserGroupConnection";
	UserGroupEdge: "UserGroupEdge";
	UserViewRecord: "UserViewRecord";
	UserViewRecordConnection: "UserViewRecordConnection";
	UserViewRecordEdge: "UserViewRecordEdge";
	Vaccine: "Vaccine";
	VaccineConnection: "VaccineConnection";
	VaccineEdge: "VaccineEdge";
};

/**
 * Stores the type name for each model for use in local GraphQL data (as the `__typename` field).
 */
export const graphTypeNames: GraphTypeNames = {
	AcademicSubject: "AcademicSubject",
	AcademicSubjectConnection: "AcademicSubjectConnection",
	AcademicSubjectEdge: "AcademicSubjectEdge",
	AcademicTerm: "AcademicTerm",
	AcademicTermConnection: "AcademicTermConnection",
	AcademicTermEdge: "AcademicTermEdge",
	AcademicYear: "AcademicYear",
	AcademicYearConnection: "AcademicYearConnection",
	AcademicYearEdge: "AcademicYearEdge",
	Address: "Address",
	AddressConnection: "AddressConnection",
	AddressEdge: "AddressEdge",
	Announcement: "Announcement",
	AnnouncementConnection: "AnnouncementConnection",
	AnnouncementEdge: "AnnouncementEdge",
	AttendanceStatus: "AttendanceStatus",
	AttendanceStatusConnection: "AttendanceStatusConnection",
	AttendanceStatusEdge: "AttendanceStatusEdge",
	BillingAdjustment: "BillingAdjustment",
	BillingAdjustmentConnection: "BillingAdjustmentConnection",
	BillingAdjustmentEdge: "BillingAdjustmentEdge",
	Building: "Building",
	BuildingConnection: "BuildingConnection",
	BuildingEdge: "BuildingEdge",
	BuildingFloor: "BuildingFloor",
	BuildingFloorConnection: "BuildingFloorConnection",
	BuildingFloorEdge: "BuildingFloorEdge",
	CalendarEvent: "CalendarEvent",
	CalendarEventConnection: "CalendarEventConnection",
	CalendarEventEdge: "CalendarEventEdge",
	CalendarEventResponse: "CalendarEventResponse",
	CalendarEventResponseConnection: "CalendarEventResponseConnection",
	CalendarEventResponseEdge: "CalendarEventResponseEdge",
	Campus: "Campus",
	CampusConnection: "CampusConnection",
	CampusEdge: "CampusEdge",
	ClassYear: "ClassYear",
	ClassYearConnection: "ClassYearConnection",
	ClassYearEdge: "ClassYearEdge",
	ClassYearCategory: "ClassYearCategory",
	ClassYearCategoryConnection: "ClassYearCategoryConnection",
	ClassYearCategoryEdge: "ClassYearCategoryEdge",
	Contract: "Contract",
	ContractConnection: "ContractConnection",
	ContractEdge: "ContractEdge",
	ContractInstallment: "ContractInstallment",
	ContractInstallmentConnection: "ContractInstallmentConnection",
	ContractInstallmentEdge: "ContractInstallmentEdge",
	ContractLineItem: "ContractLineItem",
	ContractLineItemConnection: "ContractLineItemConnection",
	ContractLineItemEdge: "ContractLineItemEdge",
	Country: "Country",
	CountryConnection: "CountryConnection",
	CountryEdge: "CountryEdge",
	Course: "Course",
	CourseConnection: "CourseConnection",
	CourseEdge: "CourseEdge",
	CourseAssessment: "CourseAssessment",
	CourseAssessmentConnection: "CourseAssessmentConnection",
	CourseAssessmentEdge: "CourseAssessmentEdge",
	CourseAssessmentCategory: "CourseAssessmentCategory",
	CourseAssessmentCategoryConnection: "CourseAssessmentCategoryConnection",
	CourseAssessmentCategoryEdge: "CourseAssessmentCategoryEdge",
	CourseAssessmentCategoryMarkPortion: "CourseAssessmentCategoryMarkPortion",
	CourseAssessmentCategoryMarkPortionConnection: "CourseAssessmentCategoryMarkPortionConnection",
	CourseAssessmentCategoryMarkPortionEdge: "CourseAssessmentCategoryMarkPortionEdge",
	CourseAssessmentMark: "CourseAssessmentMark",
	CourseAssessmentMarkConnection: "CourseAssessmentMarkConnection",
	CourseAssessmentMarkEdge: "CourseAssessmentMarkEdge",
	CourseAssessmentSubmission: "CourseAssessmentSubmission",
	CourseAssessmentSubmissionConnection: "CourseAssessmentSubmissionConnection",
	CourseAssessmentSubmissionEdge: "CourseAssessmentSubmissionEdge",
	CourseAssessmentTiming: "CourseAssessmentTiming",
	CourseAssessmentTimingConnection: "CourseAssessmentTimingConnection",
	CourseAssessmentTimingEdge: "CourseAssessmentTimingEdge",
	CourseAttendanceRecord: "CourseAttendanceRecord",
	CourseAttendanceRecordConnection: "CourseAttendanceRecordConnection",
	CourseAttendanceRecordEdge: "CourseAttendanceRecordEdge",
	CourseSection: "CourseSection",
	CourseSectionConnection: "CourseSectionConnection",
	CourseSectionEdge: "CourseSectionEdge",
	CourseSectionPeriod: "CourseSectionPeriod",
	CourseSectionPeriodConnection: "CourseSectionPeriodConnection",
	CourseSectionPeriodEdge: "CourseSectionPeriodEdge",
	Discount: "Discount",
	DiscountConnection: "DiscountConnection",
	DiscountEdge: "DiscountEdge",
	EmailAddress: "EmailAddress",
	EmailAddressConnection: "EmailAddressConnection",
	EmailAddressEdge: "EmailAddressEdge",
	Employee: "Employee",
	EmployeeConnection: "EmployeeConnection",
	EmployeeEdge: "EmployeeEdge",
	EnrollmentApplication: "EnrollmentApplication",
	EnrollmentApplicationConnection: "EnrollmentApplicationConnection",
	EnrollmentApplicationEdge: "EnrollmentApplicationEdge",
	EnrollmentApplicationGuardian: "EnrollmentApplicationGuardian",
	EnrollmentApplicationGuardianConnection: "EnrollmentApplicationGuardianConnection",
	EnrollmentApplicationGuardianEdge: "EnrollmentApplicationGuardianEdge",
	EnrollmentApplicationStudent: "EnrollmentApplicationStudent",
	EnrollmentApplicationStudentConnection: "EnrollmentApplicationStudentConnection",
	EnrollmentApplicationStudentEdge: "EnrollmentApplicationStudentEdge",
	EnrollmentApplicationStudentSchool: "EnrollmentApplicationStudentSchool",
	EnrollmentApplicationStudentSchoolConnection: "EnrollmentApplicationStudentSchoolConnection",
	EnrollmentApplicationStudentSchoolEdge: "EnrollmentApplicationStudentSchoolEdge",
	Guardian: "Guardian",
	GuardianConnection: "GuardianConnection",
	GuardianEdge: "GuardianEdge",
	HomeRoom: "HomeRoom",
	HomeRoomConnection: "HomeRoomConnection",
	HomeRoomEdge: "HomeRoomEdge",
	HomeRoomSection: "HomeRoomSection",
	HomeRoomSectionConnection: "HomeRoomSectionConnection",
	HomeRoomSectionEdge: "HomeRoomSectionEdge",
	Invoice: "Invoice",
	InvoiceConnection: "InvoiceConnection",
	InvoiceEdge: "InvoiceEdge",
	InvoiceLineItem: "InvoiceLineItem",
	InvoiceLineItemConnection: "InvoiceLineItemConnection",
	InvoiceLineItemEdge: "InvoiceLineItemEdge",
	Language: "Language",
	LanguageConnection: "LanguageConnection",
	LanguageEdge: "LanguageEdge",
	LearningObjective: "LearningObjective",
	LearningObjectiveConnection: "LearningObjectiveConnection",
	LearningObjectiveEdge: "LearningObjectiveEdge",
	LearningObjectiveCategory: "LearningObjectiveCategory",
	LearningObjectiveCategoryConnection: "LearningObjectiveCategoryConnection",
	LearningObjectiveCategoryEdge: "LearningObjectiveCategoryEdge",
	LoginRecord: "LoginRecord",
	LoginRecordConnection: "LoginRecordConnection",
	LoginRecordEdge: "LoginRecordEdge",
	MFAFactor: "MFAFactor",
	MFAFactorConnection: "MFAFactorConnection",
	MFAFactorEdge: "MFAFactorEdge",
	MFAInvalidOTPAttempt: "MFAInvalidOTPAttempt",
	MFAInvalidOTPAttemptConnection: "MFAInvalidOTPAttemptConnection",
	MFAInvalidOTPAttemptEdge: "MFAInvalidOTPAttemptEdge",
	MarkValue: "MarkValue",
	MarkValueConnection: "MarkValueConnection",
	MarkValueEdge: "MarkValueEdge",
	MarkingSystem: "MarkingSystem",
	MarkingSystemConnection: "MarkingSystemConnection",
	MarkingSystemEdge: "MarkingSystemEdge",
	MediaAttachment: "MediaAttachment",
	MediaAttachmentConnection: "MediaAttachmentConnection",
	MediaAttachmentEdge: "MediaAttachmentEdge",
	MedicalCondition: "MedicalCondition",
	MedicalConditionConnection: "MedicalConditionConnection",
	MedicalConditionEdge: "MedicalConditionEdge",
	Medication: "Medication",
	MedicationConnection: "MedicationConnection",
	MedicationEdge: "MedicationEdge",
	Message: "Message",
	MessageConnection: "MessageConnection",
	MessageEdge: "MessageEdge",
	MessageAvailabilityPeriod: "MessageAvailabilityPeriod",
	MessageAvailabilityPeriodConnection: "MessageAvailabilityPeriodConnection",
	MessageAvailabilityPeriodEdge: "MessageAvailabilityPeriodEdge",
	MessageGroup: "MessageGroup",
	MessageGroupConnection: "MessageGroupConnection",
	MessageGroupEdge: "MessageGroupEdge",
	MessageGroupArchivePoint: "MessageGroupArchivePoint",
	MessageGroupArchivePointConnection: "MessageGroupArchivePointConnection",
	MessageGroupArchivePointEdge: "MessageGroupArchivePointEdge",
	MessageTopic: "MessageTopic",
	MessageTopicConnection: "MessageTopicConnection",
	MessageTopicEdge: "MessageTopicEdge",
	Newsletter: "Newsletter",
	NewsletterConnection: "NewsletterConnection",
	NewsletterEdge: "NewsletterEdge",
	Payment: "Payment",
	PaymentConnection: "PaymentConnection",
	PaymentEdge: "PaymentEdge",
	PaymentLineItem: "PaymentLineItem",
	PaymentLineItemConnection: "PaymentLineItemConnection",
	PaymentLineItemEdge: "PaymentLineItemEdge",
	Permission: "Permission",
	PermissionConnection: "PermissionConnection",
	PermissionEdge: "PermissionEdge",
	PermissionGroup: "PermissionGroup",
	PermissionGroupConnection: "PermissionGroupConnection",
	PermissionGroupEdge: "PermissionGroupEdge",
	Person: "Person",
	PersonConnection: "PersonConnection",
	PersonEdge: "PersonEdge",
	PhoneNumber: "PhoneNumber",
	PhoneNumberConnection: "PhoneNumberConnection",
	PhoneNumberEdge: "PhoneNumberEdge",
	Post: "Post",
	PostConnection: "PostConnection",
	PostEdge: "PostEdge",
	Quotation: "Quotation",
	QuotationConnection: "QuotationConnection",
	QuotationEdge: "QuotationEdge",
	Refund: "Refund",
	RefundConnection: "RefundConnection",
	RefundEdge: "RefundEdge",
	Relationship: "Relationship",
	RelationshipConnection: "RelationshipConnection",
	RelationshipEdge: "RelationshipEdge",
	ReportCard: "ReportCard",
	ReportCardConnection: "ReportCardConnection",
	ReportCardEdge: "ReportCardEdge",
	ReportCardSection: "ReportCardSection",
	ReportCardSectionConnection: "ReportCardSectionConnection",
	ReportCardSectionEdge: "ReportCardSectionEdge",
	ReportCardSectionLearningObjective: "ReportCardSectionLearningObjective",
	ReportCardSectionLearningObjectiveConnection: "ReportCardSectionLearningObjectiveConnection",
	ReportCardSectionLearningObjectiveEdge: "ReportCardSectionLearningObjectiveEdge",
	ReportCardSectionPolicy: "ReportCardSectionPolicy",
	ReportCardSectionPolicyConnection: "ReportCardSectionPolicyConnection",
	ReportCardSectionPolicyEdge: "ReportCardSectionPolicyEdge",
	Room: "Room",
	RoomConnection: "RoomConnection",
	RoomEdge: "RoomEdge",
	SchoolAttendanceRecord: "SchoolAttendanceRecord",
	SchoolAttendanceRecordConnection: "SchoolAttendanceRecordConnection",
	SchoolAttendanceRecordEdge: "SchoolAttendanceRecordEdge",
	Service: "Service",
	ServiceConnection: "ServiceConnection",
	ServiceEdge: "ServiceEdge",
	Session: "Session",
	SessionConnection: "SessionConnection",
	SessionEdge: "SessionEdge",
	SharingRecord: "SharingRecord",
	SharingRecordConnection: "SharingRecordConnection",
	SharingRecordEdge: "SharingRecordEdge",
	SocialComment: "SocialComment",
	SocialCommentConnection: "SocialCommentConnection",
	SocialCommentEdge: "SocialCommentEdge",
	SocialReaction: "SocialReaction",
	SocialReactionConnection: "SocialReactionConnection",
	SocialReactionEdge: "SocialReactionEdge",
	Student: "Student",
	StudentConnection: "StudentConnection",
	StudentEdge: "StudentEdge",
	StudentAcademicNote: "StudentAcademicNote",
	StudentAcademicNoteConnection: "StudentAcademicNoteConnection",
	StudentAcademicNoteEdge: "StudentAcademicNoteEdge",
	StudentAcademicTermEnrollment: "StudentAcademicTermEnrollment",
	StudentAcademicTermEnrollmentConnection: "StudentAcademicTermEnrollmentConnection",
	StudentAcademicTermEnrollmentEdge: "StudentAcademicTermEnrollmentEdge",
	StudentAttendanceNote: "StudentAttendanceNote",
	StudentAttendanceNoteConnection: "StudentAttendanceNoteConnection",
	StudentAttendanceNoteEdge: "StudentAttendanceNoteEdge",
	StudentBehaviorNote: "StudentBehaviorNote",
	StudentBehaviorNoteConnection: "StudentBehaviorNoteConnection",
	StudentBehaviorNoteEdge: "StudentBehaviorNoteEdge",
	StudentCourseSectionEnrollment: "StudentCourseSectionEnrollment",
	StudentCourseSectionEnrollmentConnection: "StudentCourseSectionEnrollmentConnection",
	StudentCourseSectionEnrollmentEdge: "StudentCourseSectionEnrollmentEdge",
	StudentDataConsent: "StudentDataConsent",
	StudentDataConsentConnection: "StudentDataConsentConnection",
	StudentDataConsentEdge: "StudentDataConsentEdge",
	StudentEnrollmentApplication: "StudentEnrollmentApplication",
	StudentEnrollmentApplicationConnection: "StudentEnrollmentApplicationConnection",
	StudentEnrollmentApplicationEdge: "StudentEnrollmentApplicationEdge",
	StudentEnrollmentIntent: "StudentEnrollmentIntent",
	StudentEnrollmentIntentConnection: "StudentEnrollmentIntentConnection",
	StudentEnrollmentIntentEdge: "StudentEnrollmentIntentEdge",
	StudentHealthNote: "StudentHealthNote",
	StudentHealthNoteConnection: "StudentHealthNoteConnection",
	StudentHealthNoteEdge: "StudentHealthNoteEdge",
	StudentHomeRoomSectionEnrollment: "StudentHomeRoomSectionEnrollment",
	StudentHomeRoomSectionEnrollmentConnection: "StudentHomeRoomSectionEnrollmentConnection",
	StudentHomeRoomSectionEnrollmentEdge: "StudentHomeRoomSectionEnrollmentEdge",
	StudentIncidentNote: "StudentIncidentNote",
	StudentIncidentNoteConnection: "StudentIncidentNoteConnection",
	StudentIncidentNoteEdge: "StudentIncidentNoteEdge",
	StudentInformationVerification: "StudentInformationVerification",
	StudentInformationVerificationConnection: "StudentInformationVerificationConnection",
	StudentInformationVerificationEdge: "StudentInformationVerificationEdge",
	StudentInjuryNote: "StudentInjuryNote",
	StudentInjuryNoteConnection: "StudentInjuryNoteConnection",
	StudentInjuryNoteEdge: "StudentInjuryNoteEdge",
	StudentMedicalCondition: "StudentMedicalCondition",
	StudentMedicalConditionConnection: "StudentMedicalConditionConnection",
	StudentMedicalConditionEdge: "StudentMedicalConditionEdge",
	StudentMedicalContact: "StudentMedicalContact",
	StudentMedicalContactConnection: "StudentMedicalContactConnection",
	StudentMedicalContactEdge: "StudentMedicalContactEdge",
	StudentMedicalEvent: "StudentMedicalEvent",
	StudentMedicalEventConnection: "StudentMedicalEventConnection",
	StudentMedicalEventEdge: "StudentMedicalEventEdge",
	StudentMedicalProfile: "StudentMedicalProfile",
	StudentMedicalProfileConnection: "StudentMedicalProfileConnection",
	StudentMedicalProfileEdge: "StudentMedicalProfileEdge",
	StudentMedicationNote: "StudentMedicationNote",
	StudentMedicationNoteConnection: "StudentMedicationNoteConnection",
	StudentMedicationNoteEdge: "StudentMedicationNoteEdge",
	StudentNote: "StudentNote",
	StudentNoteConnection: "StudentNoteConnection",
	StudentNoteEdge: "StudentNoteEdge",
	StudentOTCMedication: "StudentOTCMedication",
	StudentOTCMedicationConnection: "StudentOTCMedicationConnection",
	StudentOTCMedicationEdge: "StudentOTCMedicationEdge",
	StudentPrescriptionMedication: "StudentPrescriptionMedication",
	StudentPrescriptionMedicationConnection: "StudentPrescriptionMedicationConnection",
	StudentPrescriptionMedicationEdge: "StudentPrescriptionMedicationEdge",
	StudentSocialEmotionalNote: "StudentSocialEmotionalNote",
	StudentSocialEmotionalNoteConnection: "StudentSocialEmotionalNoteConnection",
	StudentSocialEmotionalNoteEdge: "StudentSocialEmotionalNoteEdge",
	StudentVaccinationRecord: "StudentVaccinationRecord",
	StudentVaccinationRecordConnection: "StudentVaccinationRecordConnection",
	StudentVaccinationRecordEdge: "StudentVaccinationRecordEdge",
	TeacherCourseSectionEnrollment: "TeacherCourseSectionEnrollment",
	TeacherCourseSectionEnrollmentConnection: "TeacherCourseSectionEnrollmentConnection",
	TeacherCourseSectionEnrollmentEdge: "TeacherCourseSectionEnrollmentEdge",
	TeacherHomeRoomSectionEnrollment: "TeacherHomeRoomSectionEnrollment",
	TeacherHomeRoomSectionEnrollmentConnection: "TeacherHomeRoomSectionEnrollmentConnection",
	TeacherHomeRoomSectionEnrollmentEdge: "TeacherHomeRoomSectionEnrollmentEdge",
	TrustedDevice: "TrustedDevice",
	TrustedDeviceConnection: "TrustedDeviceConnection",
	TrustedDeviceEdge: "TrustedDeviceEdge",
	User: "User",
	UserConnection: "UserConnection",
	UserEdge: "UserEdge",
	UserGroup: "UserGroup",
	UserGroupConnection: "UserGroupConnection",
	UserGroupEdge: "UserGroupEdge",
	UserViewRecord: "UserViewRecord",
	UserViewRecordConnection: "UserViewRecordConnection",
	UserViewRecordEdge: "UserViewRecordEdge",
	Vaccine: "Vaccine",
	VaccineConnection: "VaccineConnection",
	VaccineEdge: "VaccineEdge",
};
